<template>
  <select
    v-model="model"
    class="form-control select-style p-2 my-1 fw-bold"
  >
    <template
      v-for="(optionValue) in operatorType"
    >
      <option
        :key="optionValue"
        :value="optionValue"
        :data-selected="optionValue"
      >
        {{ trans(`subscription.classification_config.selectors.${selectorType}.${optionValue}`) }}
      </option>
    </template>
  </select>
</template>

<script>
import { OPERATOR_TYPE } from '@/constants'
export default {
  name: 'SelectorSelectOperator',
  props: {
    value: {
      required: true,
      type: String,
    },
    selectorType: {
      required: true,
      type: String,
    },
    operatorType: {
      required: false,
      type: Object,
      default: () => OPERATOR_TYPE,
    },
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style scoped>
.form-control {
  width: auto !important;
}
</style>
